export default "/images/regel-3.jpg?9e0d89ad4a6313fa26728a9981a87224";